import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-submission-update',
  templateUrl: './participant-submission-update.component.html',
  styleUrls: ['./participant-submission-update.component.scss']
})
export class ParticipantSubmissionUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
